module.exports = __webpack_public_path__ + "img/icon02.f0f033ba.png";